<div class="container">
  <mat-card class="militar-info">
    <h2>Dados do Militar</h2>
    <div class="info-column">
      <span><strong>Matrícula:</strong> {{ beneficiario.matricula }}</span>
      <span><strong>Nome:</strong> {{ beneficiario.nome }}</span>
      <span><strong>ID Funcional:</strong> {{ beneficiario.idFuncional }}</span>
      <span><strong>CPF:</strong> {{ beneficiario.cpf }}</span>
      <span><strong>Órgão:</strong> {{ beneficiario.orgao.sigla }}</span>
    </div>
  </mat-card>

  <app-etapas-beneficio [etapaSelecionada]="4"></app-etapas-beneficio>

  <mat-card class="info-card">
    <h2>Alterações Funcionais</h2>

    <table
      mat-table
      [dataSource]="alteracoes"
      class="mat-elevation-z2"
      multiTemplateDataRows
    >
      <ng-container matColumnDef="dataInicio">
        <th mat-header-cell *matHeaderCellDef>Data Início</th>
        <td mat-cell *matCellDef="let a">
          {{ a.dataInicio | date : "dd/MM/yyyy" }}
        </td>
      </ng-container>

      <ng-container matColumnDef="dataFim">
        <th mat-header-cell *matHeaderCellDef>Data Fim</th>
        <td mat-cell *matCellDef="let a">
          {{ a.dataFim ? (a.dataFim | date : "dd/MM/yyyy") : "—" }}
        </td>
      </ng-container>

      <ng-container matColumnDef="cargo">
        <th mat-header-cell *matHeaderCellDef>Graduação/Patente</th>
        <td mat-cell *matCellDef="let a">{{ a.cargo }}</td>
      </ng-container>

      <ng-container matColumnDef="composicao">
        <th mat-header-cell *matHeaderCellDef>Composição</th>
        <td mat-cell *matCellDef="let a">{{ a.composicao }}</td>
      </ng-container>

      <ng-container matColumnDef="portaria">
        <th mat-header-cell *matHeaderCellDef>Portaria</th>
        <td mat-cell *matCellDef="let a">{{ a.portaria ?? "—" }}</td>
      </ng-container>

      <ng-container matColumnDef="diarioOficial">
        <th mat-header-cell *matHeaderCellDef>Diário Oficial</th>
        <td mat-cell *matCellDef="let a">
          {{
            a.dataPubDiarioOficial
              ? (a.dataPubDiarioOficial | date : "dd/MM/yyyy")
              : "—"
          }}
        </td>
      </ng-container>

      <ng-container matColumnDef="pagina">
        <th mat-header-cell *matHeaderCellDef>Página</th>
        <td mat-cell *matCellDef="let a">{{ a.paginaDiarioOficial ?? "—" }}</td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef>Status</th>
        <td mat-cell *matCellDef="let a">
          <span class="status-badge" [ngClass]="{
            'status-ausente': a.status === 'Ausente',
            'status-anexado': a.status === 'Anexado'
          }">{{ a.status }}</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="acoes">
        <th mat-header-cell *matHeaderCellDef>Ações</th>
        <td mat-cell *matCellDef="let a">
          <button
            mat-icon-button
            (click)="abrirModalUpload(a)"
            matTooltip="Anexar Documento"
          >
            <mat-icon color="primary">upload_file</mat-icon>
          </button>
          <button
            mat-icon-button
            (click)="downloadFile(a)"
            matTooltip="Baixar documento"
            [disabled]="!a.hashDoc"
          >
            <mat-icon>download</mat-icon>
          </button>
          <button
            mat-icon-button
            (click)="deletarDocumento(a)"
            matTooltip="Excluir Documento"
            [disabled]="!a.hashDoc"
          >
            <mat-icon color="warn">delete</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </mat-card>
  <div class="acoes-footer">
    <button mat-stroked-button color="primary" (click)="baixarRelatorio()">
      <mat-icon>download</mat-icon>
      Relatório
    </button>

    <button mat-flat-button color="accent" (click)="salvarDados()">Atualizar e Salvar Dados</button>
  </div>

  <ng-template #modalUpload let-data>
    <h2 mat-dialog-title>Anexar Documento</h2>

    <mat-dialog-content class="upload-content">
      <p><strong>Comprovação Alteração Funcional</strong></p>
      <p>Envie um arquivo PDF referente à alteração funcional selecionada.</p>

      <div class="upload-row">
        <input
          type="file"
          accept="application/pdf"
          hidden
          #fileInput
          (change)="onFileSelected($event)"
        />
        <button mat-stroked-button color="primary" (click)="fileInput.click()">
          <mat-icon>attach_file</mat-icon>
          Procurar PDF
        </button>

        <span class="file-name" *ngIf="selectedFile">{{
          selectedFile.name
        }}</span>
      </div>

      <mat-progress-bar *ngIf="uploading" mode="indeterminate">
      </mat-progress-bar>
    </mat-dialog-content>

    <mat-dialog-actions align="end" class="dialog-actions">
      <button mat-stroked-button mat-dialog-close [disabled]="uploading">
        <mat-icon>close</mat-icon> Cancelar
      </button>
      <button
        mat-flat-button
        color="primary"
        (click)="enviarDocumento()"
        [disabled]="!selectedFile || uploading"
      >
        <mat-icon>cloud_upload</mat-icon> Enviar
      </button>
    </mat-dialog-actions>
  </ng-template>
</div>
